import SubCategoriesList, { SubCategoriesListProps } from 'components/commercetools-ui/organisms/sub-category-list';
import { TasticProps } from '../types';

const SubCategoriesListTastic = ({ data }: TasticProps<SubCategoriesListProps>) => {
  const subCatConfig = data.subCatConfig;
  return <SubCategoriesList subCatConfig={subCatConfig} slides={data?.slides ?? []} />;
};

export default SubCategoriesListTastic;
